import { find, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const number = find(`.${componentPrefix}phoneNumber`, el)
  if (typeof (number) !== 'undefined' && number !== null) {
    const result = number.getAttribute('href').replace(/[^+\d]+/g, '')
    number.setAttribute('href', 'tel:' + result)
  }
}

register('personCard', component)
